# External Deal Notes View
# =====================
Backbone = require 'backbone'
Backbone.$ = $
SupportExternalDealNotesTemplate = require('../../../external_deal_notes.html.mustache')

class SupportExternalDealNotesView extends Backbone.View
  className: 'row external_deal_notes_row notification info'

  initialize: () ->
    @I18nScope = 'modules.support'
    @template = SupportExternalDealNotesTemplate
    @setExternalDealNote()

  render: ->
    @formatExternalDealNotes()
    @sortExternalDealNotes()
    if @externalDealNotes?[0]? then @externalDealNotes[0].firstNotes = true
    @$el.append toHtml(@template, @toHash(), @I18nScope)

  setExternalDealNote : () ->
    @externalDealNotes = Groupon.Support.ContentModel.externalDealNotes

  toHash: ->
    isExternalDealNotesPresent: @externalDealNotesPresent()
    externalDealNotes: @externalDealNotes
    businessName: Groupon.Support.currentOrder?.merchant?.name
    channelCode: Groupon.Support.currentOrder.DEAL_TYPE
    dealId: Groupon.Support.currentOrder.deal?.id
    country: window.country.name
    orderId: Groupon.Support.currentOrder.id

  externalDealNotesPresent: () ->
    if @externalDealNotes? then true else false

  sortExternalDealNotes: ->
    @externalDealNotes?.sort @sortbyUpdatedDate

  sortbyUpdatedDate: (a,b) ->
    a = getMillisecondsOfUTCDateFromISOStringDate a.updated_at
    b = getMillisecondsOfUTCDateFromISOStringDate b.updated_at
    (b-a)

  formatText : (text) ->
    if text?
      formatedText = ""
      subtexts = text.split('\n')
      for part in subtexts
        if part?.length > 0
          formatedText = "#{formatedText}#{part} "
          formatedText = "#{formatedText} <br/> " if part != _.last(subtexts)
      return formatedText
    else
      return text

  formatExternalDealNotes : () ->
    if @externalDealNotes?
      _.each( @externalDealNotes, (extNote)=>
        extNote.note = @formatText(extNote.note)
      )

module.exports = SupportExternalDealNotesView
